export default __webpack_public_path__ + "static/media/payment-confirmation.d3aa7561.png";